import { useCallback } from 'react'
import getBufferETAFlag from '../../../../../../../helpers/getBufferETAFlag'
import { useShoppingCartContext } from '../../../../../providers/ShoppingCartProvider'
import shoppingCartV2API from '../../../../../api'
import nrLogger from '../../../../../../../helpers/nrLogger'
import StopWatch from '../../../../../logging/StopWatch'
import trackApplyCouponValidationInCartUpdateQuantity from '../../../../../logging/gtm/trackApplyCouponValidationInCartUpdateQuantity'
import trackUpdateItemQuantity from '../../../../../logging/gtm/trackUpdateItemQuantity'
import useWmoEnabled from '../../../../../../../hooks/useWmoEnabled'
import updateCartCounter from '../../../../../logging/header/updateCartCounter'

const useSetQuantity = params => {
  const {
    data,
  } = params

  const {
    getIdentifier,
    getCartId,
    setCart,
    shouldShowLoader,
    setIsCartDataMerged,
    setItemProductIdBeingUpdated,
  } = useShoppingCartContext()

  const buffereta = getBufferETAFlag()
  const isWmoEnabled = useWmoEnabled()

  return useCallback(
    async quantity => {
      if (quantity && parseInt(quantity, 10) === data.modifiers.quantity) return

      shouldShowLoader(true)
      setItemProductIdBeingUpdated(data.product.productId)
      const items = [
        {
          product: {
            productId: data.product.productId,
            sku: data.product.sku,
            brand: {
              name: data.product.brand.name,
            },
          },
          modifiers: {
            quantity,
          },
        },
      ]

      try {
        const cartId = getCartId()
        const identifier = getIdentifier()
        const timer = new StopWatch()
        timer.start()
        const res = await shoppingCartV2API.items.update(identifier, cartId, items, buffereta)
        timer.stop()

        if (isWmoEnabled) {
          updateCartCounter(res);
          trackUpdateItemQuantity(res, items)
        }
        trackApplyCouponValidationInCartUpdateQuantity(res, timer.getElapsed())
        setCart(res)
      } catch (error) {
        nrLogger.error('ShoppingCartV2.Quantity.error', error)
        setIsCartDataMerged(true)
      }
      shouldShowLoader(false)
    },
    [
      data,
      shouldShowLoader,
      getCartId,
      getIdentifier,
      setCart,
      buffereta,
      setIsCartDataMerged,
      isWmoEnabled,
      setItemProductIdBeingUpdated,
    ],
  )
}

export default useSetQuantity
